import { render, staticRenderFns } from "./CategorySelector.vue?vue&type=template&id=fd51247a&"
import script from "./CategorySelector.vue?vue&type=script&lang=js&"
export * from "./CategorySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports